import { render, staticRenderFns } from "./DataGridColumnWrapper.vue?vue&type=template&id=7299431b"
import script from "./DataGridColumnWrapper.vue?vue&type=script&lang=js"
export * from "./DataGridColumnWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports